type Props = {
  domain: string;
  title: string;
  description: string;
  image: string | null;
};

/** Roughly how a shared link renders on LinkedIn / Slack. */
export const LinkPreview = ({ domain, title, description, image }: Props) => (
  <div className="overflow-hidden rounded-lg border border-line bg-white text-left">
    <div className="aspect-[1200/630] bg-paper">
      {image ? (
        <img src={image} alt="" className="size-full object-cover" />
      ) : (
        <div className="flex size-full items-center justify-center text-[11px] text-muted">
          No image — the brand default will be used
        </div>
      )}
    </div>
    <div className="space-y-0.5 border-t border-line px-3 py-2">
      <p className="text-[10px] uppercase tracking-wide text-muted">{domain}</p>
      <p className="line-clamp-2 text-sm font-semibold text-ink">{title || "Untitled post"}</p>
      {description && <p className="line-clamp-2 text-xs text-muted">{description}</p>}
    </div>
  </div>
);
